<template>
    <div class="update-wrap">
        <div class="update-header"></div>
        <div class="update-main">
            <div style="font-size:22px">更新信息</div>
            <el-divider></el-divider>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="题库系统" name="tiku">
                    <ul class="list">
                        <li>乐分享题库系统·网页版</li>
                        <li>乐分享题库系统·个人版</li>
                        <li>乐分享题库系统·网络客户端版</li>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="考试系统" name="kaoshi">
                    <ul class="list">
                        <li>乐分享在线考试系统</li>
                    </ul>
                </el-tab-pane>
                <el-tab-pane label="Office处理" name="office">
                    <ul class="list">
                        <li>Word批量处理大师</li>
                        <li>PPT批量处理大师</li>
                    </ul>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            activeName: 'tiku'
        }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
}
</script>
<style lang="less">
    .update-wrap{
        background-color: #F4F4F4;
        min-height: 100vh;
        padding-bottom: 30px;
        .update-header{
            height: 60px;
            background:linear-gradient(17deg,rgba(71,179,246,1),rgba(25,138,247,1))
        }
        .update-main{
            width: 1200px; 
            margin: 0 auto;
            margin-top: 30px;
            padding: 30px;
            min-height: calc(100vh - 30px);
            box-sizing: border-box;
            background-color: #fff;
            .list{
                display: flex;
                >li{
                    flex: 1;
                }
            }
            .el-tabs__nav-wrap::after{
                display: none;
            }
            .el-tabs__item{
                outline: none;
                font-size: 18px;
                font-weight: 500;
            }
            .el-tabs__item:focus.is-active.is-focus:not(:active){
                box-shadow: none;
                border-radius: 0;
            }
        }
    }
</style>